import { render, staticRenderFns } from "./billingConfirm.vue?vue&type=template&id=ecf90cfa"
import script from "./billingConfirm.vue?vue&type=script&lang=js"
export * from "./billingConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports